module.exports = __webpack_public_path__ + "static/media/lei.360b930e.svg";